import React from 'react';
import Swiper from 'swiper';
export default class FamousDoctor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render(){
        const _this = this;
        return (
            <div className="home-doctor  module-margin">
                <h3>入驻名医一览</h3> 
                <div className='swiper-container'>
                        <div className='swiper-wrapper'>
                            <div className="swiper-slide">
                                <div className="inner-item">
                                    <div className="doctor-image">
                                        <img src={ require("../assets/images/expert/gaohong.png") }/>
                                    </div> 
                                    <p className="doctor-name">高宏</p>
                                    <p className="doctor-job">中华放射学杂志</p>
                                    <p className="doctor-tips">编辑、主编</p>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="inner-item">
                                    <div className="doctor-image">
                                        <img src={ require("../assets/images/expert/gaopeiyi.jpg") }/>
                                    </div> 
                                    <p className="doctor-name">高培毅</p>
                                    <p className="doctor-job">中华医学会放射学会</p>
                                    <p className="doctor-tips">副主任委员</p>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="inner-item">
                                    <div className="doctor-image">
                                        <img src={ require("../assets/images/expert/mengjunfei.jpg") }/>
                                    </div> 
                                    <p className="doctor-name">孟悛非</p>
                                    <p className="doctor-job">广东省医学会放射学分会</p>
                                    <p className="doctor-tips">主任委员</p>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="inner-item">
                                    <div className="doctor-image">
                                        <img src={ require("../assets/images/expert/guoyoumin.png") }/>
                                    </div> 
                                    <p className="doctor-name">郭佑民</p>
                                    <p className="doctor-job">国家医学继续教育委员会影像专业组</p>
                                    <p className="doctor-tips">专家组成员</p>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="inner-item">
                                    <div className="doctor-image">
                                        <img src={ require("../assets/images/expert/lijianding.png") }/>
                                    </div> 
                                    <p className="doctor-name">李健丁</p>
                                    <p className="doctor-job">山西省青年医学专家</p>
                                    <p className="doctor-tips">山西省跨世纪学科带头人</p>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="inner-item">
                                    <div className="doctor-image">
                                        <img src={ require("../assets/images/expert/yehuiyi.jpg") }/>
                                    </div> 
                                    <p className="doctor-name">叶慧义</p>
                                    <p className="doctor-job">中央军委保健委员会</p>
                                    <p className="doctor-tips">会诊专家</p>
                                </div>
                            </div>
                        </div>
                    </div>    
            </div>
        );
    }
    componentDidMount() {
        const _this = this;
        _this.initViews();
    }
    initViews (){
        const _this = this;
        setTimeout(()=>{
            new Swiper('.swiper-container', {
                slidesPerView: "auto",
                spaceBetween: 14,
                slidesOffsetBefore : 20,
                slidesOffsetAfter : 20,
                centeredSlides: false
            });
        },500);
    }
}
